const baseStyle = {
  fontWeight: '600px',
}

const sizes = {}

const variants = {
  card: {
    fontSize: '18px',
    color: 'foreground',
    fontWeight: 600,
    lineHeight: '32px',
  },
  modal: {
    fontSize: '20px',
    color: 'foreground',
    fontWeight: 600,
    lineHeight: '32px',
  },
}

const defaultProps = {
  variant: 'card',
}

export const headingTheme = {
  baseStyle,
  sizes,
  variants,
  defaultProps,
}
